module.exports = __webpack_public_path__ + "img/accessory_shirt_15.a19b0ae3.svg";